import { render, staticRenderFns } from "./SettlementAudit.vue?vue&type=template&id=6471b83a&scoped=true&"
import script from "./SettlementAudit.vue?vue&type=script&lang=js&"
export * from "./SettlementAudit.vue?vue&type=script&lang=js&"
import style0 from "./SettlementAudit.vue?vue&type=style&index=0&id=6471b83a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6471b83a",
  null
  
)

export default component.exports